/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import InformationCircleIcon from '@atlaskit/icon/core/information-circle';
import { JiraIcon } from '@atlaskit/logo';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import {
	PanelActionBack,
	PanelActionClose,
	PanelActionExpand,
	PanelActionGroup,
	PanelActionMore,
	PanelActionNewTab,
	PanelHeader,
	PanelTitle,
} from '@atlassian/panel-system';
// Each header variation is wrapped in a bordered box purely for presentation in the docs.
// In a real panel, render `PanelHeader` directly inside a `PanelContainer`.
const styles = cssMap({
	gallery: {
		width: '400px',
	},
	headerWrapper: {
		borderColor: token('color.border'),
		borderStyle: 'solid',
		borderWidth: token('border.width'),
		borderRadius: token('radius.small'),
		overflow: 'hidden',
	},
});

function HeaderVariant({ children }: { children: React.ReactNode }) {
	return <Box xcss={styles.headerWrapper}>{children}</Box>;
}

export default function Headers(): React.JSX.Element {
	return (
		<Stack space="space.300" xcss={styles.gallery}>
			{/* Basic */}
			<HeaderVariant>
				<PanelHeader>
					<PanelTitle>Header title</PanelTitle>
					<PanelActionGroup>
						<PanelActionClose onClick={() => {}} />
					</PanelActionGroup>
				</PanelHeader>
			</HeaderVariant>

			{/* Basic + title icon */}
			<HeaderVariant>
				<PanelHeader>
					<PanelTitle icon={<InformationCircleIcon label="" />}>Header title</PanelTitle>
					<PanelActionGroup>
						<PanelActionClose onClick={() => {}} />
					</PanelActionGroup>
				</PanelHeader>
			</HeaderVariant>

			{/* Branded */}
			<HeaderVariant>
				<PanelHeader>
					<PanelTitle icon={<JiraIcon shouldUseNewLogoDesign size="xsmall" appearance="brand" />}>
						App name
					</PanelTitle>
					<PanelActionGroup>
						<PanelActionClose onClick={() => {}} />
					</PanelActionGroup>
				</PanelHeader>
			</HeaderVariant>

			{/* Branded + back button */}
			<HeaderVariant>
				<PanelHeader>
					<PanelActionBack onClick={() => {}} />
					<PanelTitle icon={<JiraIcon shouldUseNewLogoDesign size="xsmall" appearance="brand" />}>
						App name
					</PanelTitle>
					<PanelActionGroup>
						<PanelActionClose onClick={() => {}} />
					</PanelActionGroup>
				</PanelHeader>
			</HeaderVariant>

			{/* Branded + panel action */}
			<HeaderVariant>
				<PanelHeader>
					<PanelTitle icon={<JiraIcon shouldUseNewLogoDesign size="xsmall" appearance="brand" />}>
						App name
					</PanelTitle>
					<PanelActionGroup>
						<PanelActionNewTab href="#" />
						<PanelActionClose onClick={() => {}} />
					</PanelActionGroup>
				</PanelHeader>
			</HeaderVariant>
			{/* Branded + app panel + 2 panel actions */}
			<HeaderVariant>
				<PanelHeader>
					<PanelTitle icon={<JiraIcon shouldUseNewLogoDesign size="xsmall" appearance="brand" />}>
						App name
					</PanelTitle>
					<PanelActionGroup>
						<PanelActionMore onClick={() => {}} />
						<PanelActionExpand onClick={() => {}} />
						<PanelActionNewTab href="#" />
						<PanelActionClose onClick={() => {}} />
					</PanelActionGroup>
				</PanelHeader>
			</HeaderVariant>
		</Stack>
	);
}
